export default __webpack_public_path__ + "static/footer-logo-afd5b8317230be6bced78a8606101561.svg";